import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const ProfileUploadIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon {...props}>
    <svg width="44" height="45" viewBox="0 0 44 45" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dii_883_12575)">
        <rect x="2" y="1.5" width="40" height="40" rx="8" fill="white" />
        <rect x="2.5" y="2" width="39" height="39" rx="7.5" stroke="#D5D7DA" />
        <path
          d="M28.6663 29C28.6663 27.837 28.6663 27.2555 28.5228 26.7824C28.1996 25.717 27.366 24.8834 26.3006 24.5602C25.8275 24.4167 25.246 24.4167 24.083 24.4167H19.9163C18.7534 24.4167 18.1719 24.4167 17.6987 24.5602C16.6334 24.8834 15.7997 25.717 15.4765 26.7824C15.333 27.2555 15.333 27.837 15.333 29M25.7497 17.75C25.7497 19.8211 24.0707 21.5 21.9997 21.5C19.9286 21.5 18.2497 19.8211 18.2497 17.75C18.2497 15.6789 19.9286 14 21.9997 14C24.0707 14 25.7497 15.6789 25.7497 17.75Z"
          stroke="#535862"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_dii_883_12575"
          x="0"
          y="0.5"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0392157 0 0 0 0 0.0509804 0 0 0 0 0.0705882 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_883_12575" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_883_12575" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_883_12575" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect3_innerShadow_883_12575" />
          <feOffset />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.18 0" />
          <feBlend mode="normal" in2="effect2_innerShadow_883_12575" result="effect3_innerShadow_883_12575" />
        </filter>
      </defs>
    </svg>
  </SvgIcon>
);
